<template>
  <div class="section-plans-grauitous">
		<v-flex class="w-semibold primary--text text-plans" text-xs-center>
			¡Con CasaMarket da el primer paso gratis! 
		</v-flex>
		<div class="content-step">
			<v-flex text-xs-center class="secondary--text ft-text-manual w-bold">
			 	<span class="text-orange w-semibold">Gratis</span> y fácil de usar
			</v-flex>
			<v-stepper v-model="step" class="plans-stepper">
				<v-stepper-items class="plans-content">
					<v-stepper-content step="1">
						<div class="content-step-one">
							<div class="content-plan ">
								<img src="static/images-new/icons/shop.svg" alt="icon-shop">
								<span class="primary--text w-medium item-text-step">Crea tu tienda online en 2 Pasos </span>
							</div>
							<div class="mt-3 content-img-plans cont-three">
								<img :src="slideStep.imageStepOne" alt="" class="img-step-one">
							</div>
							<div class="content-plan mt-4">
								<img src="static/images-new/icons/box.svg" alt="icon-box">
								<span class="primary--text w-medium item-text-step">
									Ofrece tus Productos en tu Catálogo Virtual
								</span>
							</div>
						</div>
					</v-stepper-content>
					<v-stepper-content step="2">
						<div class="content-step-one" row wrap align-center>
							<div class="content-plan mt-4">
									<img src="static/images-new/icons/smartphone.svg" alt="icon-smartphone" height="33">
									<span class="primary--text w-medium item-text-step">
										Tu cliente realiza el pedido en tu tienda online
									</span>
							</div>
							<div class="mt-4 content-img-plans cont-three" text-xs-center>
								<img :src="slideStep.imageStepTwo" alt="" class="img-step-two">
							</div>
							<div class="content-plan mt-4">
								<v-layout align-center class="content-items-plans">
									<v-flex>
										<img src="static/images-new/icons/whatsapp-orange.svg" alt="icon-box" height="33">
									</v-flex>
									<v-flex class="primary--text w-medium item-text-step">
										Te enviamos todo el detalle del pedido a tu WhatsApp
									</v-flex>
								</v-layout>
							</div>
						</div>
					</v-stepper-content>
				</v-stepper-items>
				<v-stepper-header>
					<div class="stepper-header-container stepper__header justify-center">
						<v-stepper-step :class="{ 'active' : step === 1 }" :step="1" editable class="stepper__step--active-border item-step-1">1</v-stepper-step>
						<v-divider></v-divider>
						<v-stepper-step :step="2" editable class="stepper__step--active-border item-step-2">2</v-stepper-step>
					</div>
				</v-stepper-header>
				<v-flex text-xs-center class="primary--text text-step-one w-medium mt-4" v-if="step === 1">
					Dales el link de tu tienda online a <span class="text-orange w-bold">tus clientes</span>
				</v-flex>
				<v-flex text-xs-center v-if="step === 2" class="mt-4 w-medium primary--text text-post-plns">
					Recibe <span class="text-orange w-bold">tus pedidos</span> por Whatsapp <span>
							<img src="/static/images-new/icons/whatsapp-border-white.svg" alt="icono-whatsapp" height="45">
						</span> con todo el detalle.
				</v-flex>
			</v-stepper>
		</div>
	</div>  
</template>

<script>
function data() {
	return {
		step: 0,
		sliderIndex: 0,
		slideStep: {
			imageStepOne: '/static/images-new/sections/celular-2.png',
			imageStepTwo: '/static/images-new/sections/whatsapp.png',
		},
	};
}

export default {
	name: 'section-plans-grauitous',
	data,
};
</script>

<style lang="scss" scoped>
.section-plans-grauitous {
	position: relative;
}

.text-plans {
	background-color: #e4f3f3;
	font-size: 18px;
	padding: 25px;

	@media (min-width: 936px) {
		padding: 35px 0;
		font-size: 25px;	
	}
}

.content-step {
	background-color: #f5fbfb;
	padding: 36px 5%;

	@media (min-width: 936px) {
		padding: 54px 10%;
	}
}

.ft-text-manual {
	font-size: 20px;
}

.type-name-plans {
	font-size: 12px;
}

.content-plan {
	background-color: #ffffff;
	border-radius: 15px;
  box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.07);
	display: flex;
	font-size: 12px;
	padding: 22px 27px 22px 18px;
	width: 100%;

	@media (min-width: 936px) {
		align-items: center;
		flex-direction: column;
		height: 139px;
		margin-left: 0 !important;
		max-width: 139px;
		padding: 17px 14px 17px 14px;
		text-align: center
	}
}

.width-100 {
	width: 100%;
}

.app-slider-plans {
	background: transparent !important;
	height: 595px !important;
}

.text-orange {
	color: color(orange-cat);
}

.text-step-one {
	font-size: 16px;
	margin: 0 auto;
	max-width: 200px;

	@media (min-width: 936px) {
		font-size: 25px;
		text-align: center;
		max-width: 100%;
	}
}

.item-text-step {
	margin-left: 20px;

	@media (min-width: 936px) {
		margin: 14px 0 0 0;
	}
}

.img-step-one {
	@media (max-width: 936px) {
		width: 100%;
	}	
}

.content-step-one {
	align-items: center;
	margin-top: 30px;
	display: flex;
	justify-content: center;

	@media (max-width: 936px) {
		flex-direction: column;
	}
}

.content-img-plans {
	@media (min-width: 936px) {
		padding: 0 36px;
	}
}

.content-items-plans {
	flex-direction: row;

	@media (min-width: 936px) {
		flex-direction: column;
	}
}

.img-step-two {
	@media (max-width: 936px) {
		width: 250px;
	}
}

.text-post-plns {
	@media (max-width: 936px) {
		max-width: 238px;
		margin: 0 auto;	
	}
}

.item-step-2 {
	left: 18px;
	position: relative;
}

.item-step-1 {
	right: 18px;
	position: relative;
}

.cont-three {
	@media (max-width: 936px) {
		order: 3;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/home-new/section-plans-grauitous.vue